
import React from 'react';
import { Activity, Scale } from 'lucide-react';

const UsageInstructions = () => {
  return (
    <>
      <h2 className="text-xl md:text-2xl font-bold text-primary flex items-center gap-2 mt-6 md:mt-8">
        <Activity className="text-primary" size={20} />
        Hvordan bruke Peveo Competition Pre-Workout
      </h2>

      <div className="bg-muted p-3 md:p-6 rounded-lg border border-border mt-3 md:mt-4">
        <h4 className="font-medium text-primary mb-2 md:mb-3 text-sm md:text-base">Anbefalt dosering:</h4>
        <ul className="list-disc list-inside space-y-1 md:space-y-2 text-xs md:text-sm text-foreground">
          <li>Bland 1-2 skjeer i 300-400ml vann</li>
          <li>Innta 20-30 minutter før trening</li>
          <li>Nybegynnere bør starte med 1/2-1 skje</li>
          <li>IKKE OVERSTIG 2 SKJEER I LØPET AV 24 TIMER</li>
        </ul>
        <div className="mt-3 md:mt-4 p-2 md:p-3 border border-border rounded-lg">
          <p className="text-xs md:text-sm text-foreground">
            <span className="text-primary font-semibold">Pro-tip:</span> For optimal effekt av 
            ingrediensene, ta Peveo Competition Pre-Workout på tom mage. Du vil fortsatt få 
            prestasjonsforbedrende effekter med mat i magen, men den kognitive forbedringen vil være mindre merkbar.
          </p>
        </div>
      </div>
      
      {/* CTA / Avslutning */}
      <div className="bg-primary/10 p-3 md:p-6 rounded-lg border border-border mt-4 md:mt-6">
        <h3 className="text-lg md:text-xl font-bold text-primary mb-2 md:mb-3 flex items-center gap-2">
          <Scale className="text-primary" size={20} />
          31 gram per servering. Les det igjen.
        </h3>
        <p className="mb-3 md:mb-4 text-sm md:text-base text-foreground leading-relaxed">
          De fleste PWO-er veier 10–15g per servering. Det meste er smakstilsetning, farge og fyllingredienser. 
          Vår servering veier <span className="text-primary font-bold">31 gram</span> – fordi den er fylt med aktive ingredienser i maksimal klinisk dose.
        </p>
        <p className="text-sm md:text-base text-foreground leading-relaxed">
          Når du åpner posen og ser hvor stor skjeen er, forstår du forskjellen. 
          Dette er for de som vil ha <span className="font-bold text-primary">resultater</span>, ikke bare god smak.
        </p>
      </div>
    </>
  );
};

export default UsageInstructions;
